export enum LoanPurpose {
  None = 'Unknown',
  Refinance = 'Refinance',
  Purchase = 'Purchase',
  ConstructionOnly = 'ConstructionOnly',
  ConstructionToPermanent = 'ConstructionToPermanent',
  Other = 'Other'
}

